module.exports = __webpack_public_path__ + "static/logo-906557e57b8016e31e8b3d3240c69ffd.svg";